/**
 * Single source of truth for user-facing tier labels.
 *
 * BLOCK 56: `enterprise` has been fully retired from user-facing code paths.
 * All tier checks in the frontend must go through `isBusinessTier()` /
 * `isPaidTier()` below so we never string-match `"enterprise"` directly.
 * The backend still accepts `enterprise` on the wire as a legacy alias; do
 * not compare to it here.
 */

const TIER_LABELS = {
  free: "FREE",
  pro: "PRO",
  business: "BUSINESS",
};

const BUSINESS_TIER_KEYS = new Set(["business", "enterprise", "agency"]);
const PAID_TIER_KEYS = new Set(["pro", "business", "enterprise", "agency"]);

/**
 * Return the display label for a tier key.
 * Unknown values fall through to uppercase of the input.
 * @param {string|undefined} t
 * @returns {string}
 */
export function tierLabel(t) {
  const key = (t || "free").toLowerCase();
  if (BUSINESS_TIER_KEYS.has(key)) return "BUSINESS";
  return TIER_LABELS[key] || String(t || "").toUpperCase();
}

/**
 * True if the given tier is Business (or its legacy backend aliases).
 * @param {string|undefined} t
 */
export function isBusinessTier(t) {
  return BUSINESS_TIER_KEYS.has((t || "").toLowerCase());
}

/**
 * True if the given tier is any paid tier (Pro or Business).
 * @param {string|undefined} t
 */
export function isPaidTier(t) {
  return PAID_TIER_KEYS.has((t || "").toLowerCase());
}
